import { useEffect, useState } from "react";
import Button from "../../../Custom/Button/Button";
import styles from "./styles";
import CustomSelect from "../globalno-dodavanje/CustomSelect";
import CustomCalendarInput from "./CustomCalendarInput";
import { useGlobalContext } from "../../../../Context/Context";
import LatinicaWarningModal from "./LatinicaWarningModal";
import axios from "axios";

const nowDate = new Date()
  .toLocaleDateString("sr-RS", { day: "2-digit", month: "2-digit", year: "2-digit" })
  .replaceAll("/", ".")
  .slice(0, -1);

const emptyObrazac = {
  lzo: { id: "", name: "" },
  radnoMesto: { id: "", name: "" },
  datum: nowDate,
  rok: "",
  zaposlen: { id: "", name: "" },
  nazivDokumenta: ""
};

const dvocifrenRegex = /^([1-9]\d?)?$/;

const formatDateForApi = (dateStr) => {
  if (!dateStr) return null;
  const parts = dateStr.replace(/\.$/, "").split(".");
  if (parts.length < 3) return null;
  const year = parts[2].length === 2 ? (parseInt(parts[2]) < 50 ? "20" : "19") + parts[2] : parts[2];
  return `${year}-${parts[1]}-${parts[0]}`;
};

function EvidencijeObrazac11Dodavanje({ setIsDodavanje, onRefresh }) {
  const [obrazac, setObrazac] = useState(emptyObrazac);
  const [lzoAll, setLzoAll] = useState([]);
  const [radnaMestaAll, setRadnaMestaAll] = useState([]);
  const [zaposleniAll, setZaposleniAll] = useState([]);
  const [openLatinicaModal, setOpenLatinicaModal] = useState(false);

  const { dictionary, baseUrl, selectedMainEntity } = useGlobalContext();

  useEffect(() => {
    const fetchLookups = async () => {
      try {
        const { data } = await axios.post(`${baseUrl}/evidencija11/get_lookups.php`, {
          company_id: selectedMainEntity.company_id
        });
        if (data.status === 200) {
          setLzoAll(data.lzo);
          setRadnaMestaAll(data.radna_mesta);
          setZaposleniAll(data.zaposleni);
        }
      } catch (e) { console.error(e); }
    };
    if (selectedMainEntity?.company_id) fetchLookups();
  }, []);

  const handleKeyDown = (e) => {
    if (/^[A-Za-z]$/.test(e.key)) {
      e.preventDefault();
      setOpenLatinicaModal(true);
    }
  };

  const handleChange = (newValue, field) => {
    if (field === "rok" && !dvocifrenRegex.test(newValue)) return;
    setObrazac(prev => ({ ...prev, [field]: newValue }));
  };

  const handleSacuvaj = async () => {
    try {
      const { data } = await axios.post(`${baseUrl}/evidencija11/create.php`, {
        company_id: selectedMainEntity.company_id,
        lzo_id: obrazac.lzo.id,
        workplace_id: obrazac.radnoMesto.id,
        employee_id: obrazac.zaposlen.id,
        datum_izdavanja: formatDateForApi(obrazac.datum),
        rok_meseci: obrazac.rok || null,
        naziv_dokumenta: obrazac.nazivDokumenta,
      });
      if (data.status === 200) {
        onRefresh();
        setIsDodavanje(false);
      }
    } catch (e) { console.error(e); }
  };

  const isDisabledSacuvaj =
    !obrazac.lzo.id ||
    !obrazac.zaposlen.id ||
    !obrazac.radnoMesto.id ||
    !obrazac.datum ||
    !obrazac.nazivDokumenta;

  return (
    <div>
      <div style={{ display: "flex", gap: "10px", width: "100%", justifyContent: "space-between", alignItems: "flex-end" }}>
        <div style={{ width: "15vw" }}>
          <CustomSelect
            label={dictionary["lzo"] || "LZO"}
            allValues={lzoAll}
            selectedValue={obrazac.lzo}
            onSelectChange={(v) => handleChange(v, "lzo")}
          />
        </div>
        <div style={{ width: "15vw" }}>
          <CustomSelect
            label={dictionary["radnoMesto"] || "Radno mesto"}
            allValues={radnaMestaAll}
            selectedValue={obrazac.radnoMesto}
            onSelectChange={(v) => handleChange(v, "radnoMesto")}
          />
        </div>
        <div>
          <CustomCalendarInput
            label={dictionary["datum"] || "Datum"}
            value={obrazac.datum}
            onChange={(v) => handleChange(v, "datum")}
          />
        </div>
        <div>
          <div style={styles.natpis}>{dictionary["rok"] || "Rok"}</div>
          <div style={{ display: "flex", gap: "3px", alignItems: "center" }}>
            <input
              value={obrazac.rok}
              onChange={(e) => handleChange(e.target.value, "rok")}
              style={{ fontSize: "14px", height: "40px", padding: "0 8px", width: "4vw" }}
            />
            <div style={{ fontWeight: "bold", fontSize: "13px" }}>
              {dictionary["mesec"] || "mes."}
            </div>
          </div>
        </div>
        <div style={{ width: "15vw" }}>
          <CustomSelect
            label={dictionary["imeIPrezime"] || "Ime i prezime"}
            allValues={zaposleniAll}
            selectedValue={obrazac.zaposlen}
            onSelectChange={(v) => handleChange(v, "zaposlen")}
          />
        </div>
        <div>
          <div style={styles.natpis}>{dictionary["nazivDokumenta"] || "Naziv dokumenta"}</div>
          <input
            value={obrazac.nazivDokumenta}
            onKeyDown={handleKeyDown}
            onChange={(e) => handleChange(e.target.value, "nazivDokumenta")}
            style={{ fontSize: "14px", height: "40px", padding: "0 8px", width: "15vw" }}
          />
        </div>
      </div>

      <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "20px" }}>
        <div onClick={() => setIsDodavanje(false)}>
          <Button activation={true} style={styles.button}>{dictionary["odustani"] || "Odustani"}</Button>
        </div>
        <div onClick={isDisabledSacuvaj ? undefined : handleSacuvaj} style={{ opacity: isDisabledSacuvaj ? 0.5 : 1 }}>
          <Button isDisabled={isDisabledSacuvaj} activation={true} style={styles.button}>
            САЧУВАЈ
          </Button>
        </div>
      </div>

      {openLatinicaModal && <LatinicaWarningModal handleCancel={() => setOpenLatinicaModal(false)} />}
    </div>
  );
}

export default EvidencijeObrazac11Dodavanje;